import { meshNode, type MeshNode, updateMesh } from '@/lib/threeScene/nodes/mesh';
import { stopAll, type StopHandle } from '@/util';
import { type LoadGeometry, updateGeometryFromSource } from '@/lib/threeScene/nodes/meshGeometry';
import type { OverlaySceneContext } from '@/views/dicoms/overlay/scene/overlaySceneContext';

/** Identifier for 'named' meshes in the scene */
export type OverlayMeshId = 'operative-femur';

export type OverlayMeshNode = MeshNode & {
    readonly plannerId: OverlayMeshId;
};

export function overlayMeshNode(
    meshID: OverlayMeshId,
    properties?: Partial<OverlayMeshNode>,
): OverlayMeshNode {
    return {
        plannerId: meshID,
        ...meshNode(meshID, {
            name: meshID,
            ...properties,
            renderOrder: renderOrder[meshID],
        }),
    };
}

export function updateOverlayMesh(
    context: OverlaySceneContext,
    node: OverlayMeshNode,
    loadGeometry: LoadGeometry,
): StopHandle {
    return stopAll(updateMesh(context, node), updateGeometryFromSource(node, loadGeometry));
}

/**
 * The render-order that should be applied to 3D objects
 *
 * @see {https://threejs.org/docs/#api/en/core/Object3D.renderOrder}
 */
const renderOrder: Record<OverlayMeshId, number> = {
    'operative-femur': 0,
};
